import script from "./DropDownRouterOption.vue?vue&type=script&setup=true&lang=js"
export * from "./DropDownRouterOption.vue?vue&type=script&setup=true&lang=js"

import "./DropDownRouterOption.vue?vue&type=style&index=0&id=4b6bd7fc&lang=css"

const __exports__ = script;

export default __exports__